module.exports = __webpack_public_path__ + "static/img/01.f8dacef5.jpg";